import { render, staticRenderFns } from "./workflowactionhist.vue?vue&type=template&id=76b0cb1d"
import script from "./workflowactionhist.vue?vue&type=script&lang=js"
export * from "./workflowactionhist.vue?vue&type=script&lang=js"
import style0 from "./workflowactionhist.vue?vue&type=style&index=0&id=76b0cb1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports